import { aroFetch } from "../aroApi";
import {
  QuarantineDetail,
  QuarantineListResponse,
  QuarantinePromoteResponse,
  QuarantineSearchParams,
} from "../../types/aro";

export async function fetchQuarantine(params: QuarantineSearchParams): Promise<QuarantineListResponse> {
  const qs = new URLSearchParams();
  if (params.file_id)                            qs.set("file_id", params.file_id);
  if (params.status && params.status !== "all")  qs.set("status",  params.status);
  if (params.reason && params.reason !== "all")  qs.set("reason",  params.reason);
  qs.set("limit",  String(params.limit  ?? 50));
  qs.set("offset", String(params.offset ?? 0));
  return aroFetch<QuarantineListResponse>(`/api/quarantine?${qs.toString()}`);
}

export async function fetchQuarantineById(id: string | number): Promise<QuarantineDetail> {
  return aroFetch<QuarantineDetail>(`/api/quarantine/${id}`);
}

/** corrected_fields use canonical names: email, credential_id, full_name, linkedin_url, earned_date, ... */
export async function updateQuarantine(
  id: string | number,
  fields: {
    corrected_fields?:    Record<string, string>;
    certificate_type_id?: number | null;
    event_id?:            number | null;
  },
  changed_by: string
): Promise<QuarantineDetail> {
  return aroFetch<QuarantineDetail>(`/api/quarantine/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ ...fields, changed_by }),
  });
}

export async function promoteQuarantine(id: string | number, changed_by: string): Promise<QuarantinePromoteResponse> {
  return aroFetch<QuarantinePromoteResponse>(`/api/quarantine/${id}/promote`, {
    method: "POST",
    body: JSON.stringify({ changed_by }),
  });
}

export async function discardQuarantine(id: string | number, changed_by: string): Promise<QuarantineDetail> {
  return aroFetch<QuarantineDetail>(`/api/quarantine/${id}/discard`, {
    method: "POST",
    body: JSON.stringify({ changed_by }),
  });
}
